<template>
  <div>
    <h4>{{ sign.format }}</h4>
    <h2>{{ sign.title_en }}</h2>

    <div class="description" v-html="sign.description_en"></div>

     <dl>
      <dt>Format</dt>
      <dd v-if="sign.format == 'Digital'">{{ sign.digital }}</dd>
      <dd v-else>{{ sign.physical }}</dd>
      <dt>Location</dt>
      <dd>{{ sign.location }}</dd>
    </dl>


    <div class="pictos">
      <div v-for="picto in sign.pictos" :key="picto.id" class="picto">
        <p>{{ picto.title_en }}</p>
        <img :src="picto.src" alt="" class="img-icon" />
      </div>
    </div>
    <v-btn
      class="edit"
      text
      :to="`/users/project/${$route.params.id}/pictos/edit/${sign.id}`"
      >Edit</v-btn
    >
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "PictosCard",
  data() {
    return {
      open: false,
    };
  },
  props: {
    sign: Object,
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>
